import React, {useState, useEffect, Fragment} from 'react'
import { Icon } from 'semantic-ui-react'


export function Marker(props){
    return (
        <div style={{
            display: 'inline-block',
            width: '35px',
            height: '19px',
            backgroundColor: '#FFFFFF',
            textAlign: 'center',
            fontSize: '13px',
            lineHeight: '19px',
            marginRight: '10px',
            color: (props.marker === '&')?'#00A700':(props.marker === '||')?'#A70000':''
        }}>
            {(props.marker === '&')?'und':(props.marker === '||')?'oder':(props.marker === '+')?
                <a><Icon name="plus" /></a>
            :'•'}
        </div>
    )

}
		
		